var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"margin-top":"20px"}},[_c('span',[_vm._v(" "+_vm._s(_vm.$t("registSuccess.wel").format(this.$parent.brandConfig.display))+". ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }